import React from 'react'
import { useDispatch } from 'react-redux'
import { intl } from 'lang/intl'

import { TtButton, TtIcon, TtTooltip } from '@23/ui-react'

import { secondCameraTriggered } from '../../../actions'

export const SecondCam = () => {
  const dispatch = useDispatch()

  const getTooltipContent = () => {
    return intl.formatMessage({ defaultMessage: 'Add a 2ndCam' })
  }

  const getAriaLabel = () => {
    return intl.formatMessage({ defaultMessage: 'Add a second camera' })
  }

  const onClickHandler = () => {
    dispatch(secondCameraTriggered())
  }

  return (
    <TtTooltip content={getTooltipContent()} placement="left" distance={16}>
      <TtButton
        circle
        aria-label={getAriaLabel()}
        onClick={onClickHandler}
        color="secondary"
      >
        <TtIcon library="one/webinars" name="2nd-cam" />
      </TtButton>
    </TtTooltip>
  )
}
